<template>
  <label class="mb-3 label-content-wrapper" :for="inputConfig.id">{{ inputConfig.name }}</label>

  <template v-if="inputConfig.config.image">
    <div class="input-group is-invalid text-left mb-3" dir="ltr">
      <div class="custom-file">
        <input @change="handleFileChange" type="file" class="custom-file-input" id="editor-upload-file">
        <label class="custom-file-label" for="editor-upload-file">انتخاب عکس</label>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary" @click="submitImage" type="button">ثبت</button>
      </div>
    </div>
  </template>

  <editor :init="init"
          v-model="form[inputConfig.id]"
          :placeholder="inputConfig.placeholder"
          :required="inputConfig.required"
  ></editor>

</template>

<script>
import tinymce from 'tinymce/tinymce.js';

// Import TinyMCE plugins and styles
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/table';
import 'tinymce/plugins/quickbars';

// Import TinyMCE Vue editor component
import Editor from '@tinymce/tinymce-vue';
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";


export default {
  components: {Editor},
  props: {
    inputConfig: {},
    form: {},
  },
  data() {
    return {
      init: {
        height: 500,
        menubar: false,
        content_css: false,
        skin: false,
        // plugins: props.plugins,  // Using the prop `plugins`, default if not provided
        toolbar: 'undo redo | bold italic underline strikethrough code | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist  | forecolor backcolor   removeformat | pagebreak | charmap emoticons | fullscreen  preview print | insertfile image media  template link  codesample | a11ycheck ltr rtl | showcomments addcomment',
        quickbars_insert_toolbar: false,
        directionality: "rtl",
        branding: false,
      },
      files: []
    }
  },
  methods: {
    handleFileChange(event) {
      this.files = event.target.files;
    },
    async submitImage() {
      let form = {
        selectedFiles: this.files
      }
      console.log(form)
      this.$store.dispatch('FileManager/uploadImageFiles', form).then(res => {
        let data = res.data.data[0].file
        console.log(data)
        this.form[this.inputConfig.id] += `<img src="${data}" alt="${findAttributeOnSiteInfo('site_name')[0]}" class="img-fluid w-100" >`
      })

    }
  },
  mounted() {

  }
}


</script>
